import { Typeof } from 'utils';

class CEGID {

    static queryParams(params = null) {

        if(Typeof.object(params)) {
          return '?' + Object.entries(params).map(([key, val]) => `${key}=${val}`).join('&');
        }
    
        return '';
      }

    static get(route, params = null) {

        return new Promise((resolve, reject) => {

          fetch(`https://api.quote.equimetre.com${route}${CEGID.queryParams(params)}`)
          .then(response => response.json())
          .then(data => {
            resolve(data.invoices)
          })
          .catch((error) => {
            reject(error);
          });
    
        });
    
      }

}

export default CEGID;